export type DeduplicatedSuggestionRow =
  | { type: 'error'; data: any; rowNum: number }
  | { type: 'notfound'; data: any; rowNum: number }
  | { type: 'result'; data: any; query: string; rowNum: number };

export function deduplicateSuggestionsData(suggestionsData: any[]): DeduplicatedSuggestionRow[] {
  if (!Array.isArray(suggestionsData) || suggestionsData.length === 0) {
    return [];
  }

  const seenResults = new Set<string>();
  const seenQueries = new Set<string>();
  const dedup: DeduplicatedSuggestionRow[] = [];
  let rowNum = 1;

  suggestionsData.forEach(item => {
    if (item.validationError) {
      if (!seenQueries.has(item.query)) {
        seenQueries.add(item.query);
        dedup.push({ type: 'error', data: item, rowNum: rowNum++ });
      }
    } else if (item.found && Array.isArray(item.results)) {
      item.results.forEach((result: any) => {
        if (!result) return;
        const resultString = JSON.stringify(result);
        if (!seenResults.has(resultString)) {
          seenResults.add(resultString);
          dedup.push({ type: 'result', data: result, query: item.query, rowNum: rowNum++ });
        }
      });
    } else if (!item.found && !seenQueries.has(item.query)) {
      seenQueries.add(item.query);
      dedup.push({ type: 'notfound', data: item, rowNum: rowNum++ });
    }
  });

  return dedup;
}

export function countUniqueFoundResults(suggestionsData: any[]): number {
  return deduplicateSuggestionsData(suggestionsData).filter(row => row.type === 'result').length;
}

export type AdvancedSearchDownloadRow = Record<string, unknown> & { __query: string };

export function buildAdvancedSearchDownloadRows(
  suggestionsData: any[],
  selectedItems?: any[],
): AdvancedSearchDownloadRow[] {
  const selectedSet =
    selectedItems && selectedItems.length > 0
      ? new Set(selectedItems.map(item => JSON.stringify(item)))
      : null;

  const rows: AdvancedSearchDownloadRow[] = [];

  deduplicateSuggestionsData(suggestionsData).forEach(row => {
    if (row.type !== 'result') return;

    const resultString = JSON.stringify(row.data);
    if (selectedSet && !selectedSet.has(resultString)) return;

    rows.push({
      ...(row.data as Record<string, unknown>),
      __query: row.query ?? '',
    });
  });

  return rows;
}
